export enum SchoolTypeEnum {
  ECOLE_PRIMAIRE = "ECOLE_PRIMAIRE",
  ETABLISSEMENT_SECONDAIRE = "ETABLISSEMENT_SECONDAIRE",
}

export const schoolTypeEnumLabels = {
  [SchoolTypeEnum.ECOLE_PRIMAIRE]: "Ecole Primaire",
  [SchoolTypeEnum.ETABLISSEMENT_SECONDAIRE]: "Enseignement secondaire",
}
